export default "__VITE_ASSET__CiFPui8A_$ZTgE8r2TbwIw__"